'use client';

import { useEffect, useState } from 'react';

interface MetricsBarProps {
  language: 'en' | 'es';
}

const MetricsBar = ({ language }: MetricsBarProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('metrics-bar');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const metrics = {
    en: [
      { id: 'metric_response', label: 'Response Time', value: '<24h' },
      { id: 'metric_retention', label: 'Client Retention', value: '94%' },
      { id: 'metric_case', label: 'Avg Case Length', value: '3.2mo' },
    ],
    es: [
      { id: 'metric_response', label: 'Tiempo de Respuesta', value: '<24h' },
      { id: 'metric_retention', label: 'Retención de Clientes', value: '94%' },
      { id: 'metric_case', label: 'Duración Promedio', value: '3.2m' },
    ],
  };

  return (
    <section id="metrics-bar" className="py-20 px-6 bg-muted">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {metrics[language].map((metric, index) => (
            <div
              key={metric.id}
              className={`text-center ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="font-mono text-5xl font-bold text-foreground mb-2">
                {metric.value}
              </div>
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsBar;